<template>
  <main class="profile-page afro-bg">
    <section class="profile-card paper-panel">
      <p class="eyebrow">Mi perfil</p>
      <h1>Datos de cuenta</h1>
      <p class="intro">Actualiza tu informacion de contacto. Estos datos ayudan a vincular tu wallet y tus puntos.</p>

      <div v-if="loading" class="state-card">Cargando perfil...</div>
      <form v-else class="profile-form" @submit.prevent="handleUpdate">
        <label>
          <span class="afro-label">Nombre</span>
          <input v-model.trim="nombre" type="text" placeholder="Nombre y apellido" class="afro-input" />
        </label>
        <label>
          <span class="afro-label">Correo</span>
          <input v-model.trim="email" type="email" placeholder="ejemplo@mail.com" class="afro-input" />
        </label>
        <label>
          <span class="afro-label">Telefono</span>
          <input :value="telefono" type="tel" inputmode="numeric" maxlength="10" placeholder="5571107484" class="afro-input" @input="onPhoneInput" />
        </label>
        <label>
          <span class="afro-label">Nueva contrasena</span>
          <input v-model="password" type="password" placeholder="Opcional, minimo 8 caracteres" class="afro-input" />
        </label>
        <label>
          <span class="afro-label">Confirmar contrasena</span>
          <input v-model="confirmPassword" type="password" class="afro-input" />
        </label>
        <label v-if="isAdmin" class="role-field">
          <span class="afro-label">Rol</span>
          <select v-model="role" class="afro-select">
            <option v-for="option in availableRoles" :value="option.value" :key="option.value">{{ option.text }}</option>
          </select>
        </label>
        <p v-if="message" class="message" :class="messageType">{{ message }}</p>
        <button type="submit" class="afro-btn" :disabled="saving">{{ saving ? 'Guardando...' : 'Guardar cambios' }}</button>
      </form>
    </section>
  </main>
</template>

<script>
import axios from 'axios'

export default {
  props: ['token'],
  data() {
    return {
      nombre: '', email: '', telefono: '', role: 'usuario', password: '', confirmPassword: '',
      loading: true, saving: false, message: '', messageType: 'success', availableRoles: []
    }
  },
  computed: {
    userRole() { return this.$store.state.role },
    isAdmin() { return ['administrador', 'superadministrador'].includes(this.userRole) }
  },
  async created() { await this.loadData() },
  methods: {
    authConfig() { return { headers: { Authorization: `Bearer ${this.$store.state.user?.token}` } } },
    async loadData() {
      this.loading = true
      try {
        const { data } = await axios.get(`/api/users/${this.token}`, this.authConfig())
        const user = data.user || {}
        this.nombre = user.nombre || ''
        this.email = user.email || ''
        this.telefono = String(user.telefono || '').replace(/\D/g, '').slice(0, 10)
        this.role = user.role || 'usuario'
        this.availableRoles = this.getAvailableRoles()
      } catch (_error) {
        this.show('No se pudo cargar tu perfil.', 'error')
      } finally {
        this.loading = false
      }
    },
    onPhoneInput(event) { this.telefono = String(event.target.value || '').replace(/\D/g, '').slice(0, 10) },
    async handleUpdate() {
      if (!this.validateEmail(this.email)) return this.show('Escribe un correo valido.', 'error')
      if (this.telefono && this.telefono.length !== 10) return this.show('El telefono debe tener 10 digitos.', 'error')
      if (this.password && this.password.length < 8) return this.show('La contrasena debe tener al menos 8 caracteres.', 'error')
      if (this.password !== this.confirmPassword) return this.show('Las contrasenas no coinciden.', 'error')
      this.saving = true
      try {
        await axios.post(`/api/users/${this.token}`, {
          nombre: this.nombre,
          email: this.email,
          telefono: this.telefono,
          role: this.isAdmin ? this.role : undefined,
          password: this.password || undefined
        }, this.authConfig())
        this.password = ''
        this.confirmPassword = ''
        this.show('Perfil actualizado.', 'success')
      } catch (error) {
        this.show(error.response?.data?.error || 'Hubo un problema al actualizar tu perfil.', 'error')
      } finally {
        this.saving = false
      }
    },
    getAvailableRoles() {
      if (this.userRole === 'superadministrador') return [
        { value: 'superadministrador', text: 'Super Administrador' },
        { value: 'administrador', text: 'Administrador' },
        { value: 'usuario', text: 'Usuario' }
      ]
      if (this.userRole === 'administrador') return [
        { value: 'administrador', text: 'Administrador' },
        { value: 'usuario', text: 'Usuario' }
      ]
      return [{ value: 'usuario', text: 'Usuario' }]
    },
    validateEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) },
    show(text, type = 'success') { this.message = text; this.messageType = type }
  }
}
</script>

<style scoped>
.profile-page { min-height: 100vh; display: grid; place-items: center; padding: clamp(16px, 4vw, 40px); color: var(--afro-ink); }
.profile-card { width: min(100%, 560px); padding: clamp(22px, 4vw, 34px); text-align: center; }
.eyebrow { margin: 0 0 8px; color: var(--afro-gold); font-weight: 1000; text-transform: uppercase; letter-spacing: .16em; }
h1 { margin: 0; font-family: var(--afro-text-serif); font-size: clamp(36px, 7vw, 52px); color: var(--afro-ink); }
.intro { max-width: 410px; margin: 10px auto 20px; color: var(--afro-olive); font-weight: 800; line-height: 1.45; }
.profile-form { display: grid; gap: 13px; text-align: left; }
.profile-form .afro-btn { width: 100%; margin-top: 6px; }
.state-card { padding: 22px; font-weight: 900; color: var(--afro-olive); }
.message { border-radius: 14px; padding: 10px 12px; text-align: center; font-weight: 900; }
.message.success { background: #dcfce7; color: #166534; }
.message.error { background: #fee2e2; color: #991b1b; }
</style>
